export default __webpack_public_path__ + "static/media/food1.3df178c9.jpg";